/* eslint-disable @typescript-eslint/no-explicit-any */
import { all, put, takeLatest } from "redux-saga/effects";
import {
  fetchCampaigns,
  fetchCampaignsError,
  fetchCampaignsSuccess,
} from "../slices/campaign/campaignSlice";
import axios, { AxiosResponse } from "axios";
import { FetchTaboolaCampaignsApiResponse } from "../slices/campaign/campaignTypes";
import { API_BACKEND_URL } from "../../utils/envUtils";
import { ErrorCause } from "../../types/ErrorTypes";
import * as Sentry from "@sentry/react";

function* fetchCampaignsFunc() {
  try {
    const res: AxiosResponse<FetchTaboolaCampaignsApiResponse> =
      yield axios.get<FetchTaboolaCampaignsApiResponse>(
        API_BACKEND_URL + "/api/taboola/getCampaigns"
      );
    const data = res.data.data?.results;
    yield put(fetchCampaignsSuccess(data || []));
  } catch (err: any) {
    Sentry.captureException(err);
    yield put(
      fetchCampaignsError({
        cause: ErrorCause.UNKNOWN,
        message: `Error when fetching campaigns. ${err?.message}`,
      })
    );
  }
}

export function* campaignSaga() {
  yield all([takeLatest(fetchCampaigns.type, fetchCampaignsFunc)]);
}
